module.exports = __webpack_public_path__ + "img/prestashop_2.31a1afe9.png";